'use client'

import { useEffect, useState } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { motion, AnimatePresence } from 'framer-motion'
import { Suspense } from 'react'

/* ─── Inner component that reads router state ────────────────────────────── */
function LoadingBarInner() {
  const pathname     = usePathname()
  const searchParams = useSearchParams()
  const [loading, setLoading]   = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    /* Each time the route changes, briefly show the bar */
    setLoading(true)
    setProgress(20)

    const t1 = setTimeout(() => setProgress(60),  150)
    const t2 = setTimeout(() => setProgress(85),  350)
    const t3 = setTimeout(() => {
      setProgress(100)
      setTimeout(() => setLoading(false), 200)
    }, 550)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
    }
  }, [pathname, searchParams])

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          key="loading-bar"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.3 } }}
          className="fixed top-0 left-0 right-0 z-[9999] h-[3px] pointer-events-none"
          style={{ background: 'transparent' }}
          aria-hidden="true"
        >
          <motion.div
            className="h-full rounded-full"
            style={{
              background: 'linear-gradient(90deg, #8B4513 0%, #D2691E 50%, #DAA520 100%)',
              originX:    0,
              boxShadow:  '0 0 8px rgba(210, 105, 30, 0.7)',
            }}
            initial={{ scaleX: 0 }}
            animate={{ scaleX: progress / 100 }}
            transition={{ ease: 'easeOut', duration: 0.3 }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
}

/* ─── Exported wrapper with Suspense ────────────────────────────────────── */
export default function LoadingBar() {
  return (
    <Suspense>
      <LoadingBarInner />
    </Suspense>
  )
}
